export default class Disposable {
  private disposers: (() => void)[] = [];
  protected addDisposer(disposer: () => void) {
    this.disposers.push(disposer);
  }

  dispose = () => {
    for (const disposer of this.disposers) {
      disposer();
    }
    this.disposers = [];
  };
}
